import { Checkbox, createStyles, FormControlLabel, makeStyles, Theme } from '@material-ui/core';
import {
  CheckBoxOutlineBlank,
  CheckBoxOutlined,
  IndeterminateCheckBoxOutlined,
} from '@material-ui/icons';
import React, { Dispatch, SetStateAction } from 'react';
import { KeywordFilteringGq } from '../../../graphql/projects/models/KeywordFilteringGq';
import VoxelTooltipShort from '../../voxel/Tooltip/VoxelTooltipShort';

export interface ArchiveCheckboxProps {
  filterState: KeywordFilteringGq;
  setFilterState: Dispatch<SetStateAction<KeywordFilteringGq>>;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    controlLabel: theme.typography.body2,
  })
);

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxOutlined fontSize="small" color={'primary'} />;
const indeterminateIcon = <IndeterminateCheckBoxOutlined fontSize="small" color={'primary'} />;

export const ArchiveCheckbox: React.FC<ArchiveCheckboxProps> = ({
  filterState,
  setFilterState,
}) => {
  const classes = useClasses();
  return (
    <VoxelTooltipShort
      message={`${filterState.archived == false ? 'Normal' : ''}${filterState.archived == true ? 'Archived' : ''
        }${filterState.archived == null ? 'All' : ''} showing`}
    >
      <FormControlLabel
        label="Archived"
        classes={{ label: classes.controlLabel }}
        control={
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            indeterminateIcon={indeterminateIcon}
            checked={filterState.archived === true}
            indeterminate={filterState.archived === null}
            color="default"
            size={'small'}
            onClick={() => {
              setFilterState((prev) => {
                if (prev.archived === false) {
                  return { ...prev, archived: true };
                }
                if (prev.archived === true) {
                  return { ...prev, archived: null };
                }
                return { ...prev, archived: false };
              });
            }}
          />
        }
      />
    </VoxelTooltipShort>
  );
};

export default ArchiveCheckbox;
